<template>
  <div class="form__group" :class="[getExternalClass]">
    <div class="form__input form__input--selection" :class="isFocused">
      <input
        type="checkbox"
        :id="id"
        :value="value"
        :required="required"
        @input="updateValue($event.currentTarget.checked)"
        @focus="onChange"
        @blur="onBlur"
        :disabled="disabled"
      />
      <label v-if="allowLabelHtml" :for="id" v-html="label"></label>
      <label v-else :for="id">{{ label }}</label>
      <lennoc-icon image="check--large"></lennoc-icon>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseCheckbox',
  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    allowLabelHtml: {
      type: Boolean,
      default () {
        return false
      }
    },
    value: {
      type: Boolean,
      default () {
        return false
      }
    },
    required: {
      type: Boolean,
      default () {
        return false
      }
    },
    domClass: {
      type: String,
      default () {
        return ''
      }
    },
    disabled: {
      type: Boolean,
      default () {
        return undefined
      }
    }
  },
  watch: {
    value () {
      this.currentValue = this.value
    }
  },
  data () {
    return {
      currentValue: false,
      hasFocus: false
    }
  },
  methods: {
    updateValue: function (value) {
      this.currentValue = value
      this.$emit('input', value)
    },
    onChange (event) {
      this.hasFocus = true
    },
    onBlur () {
      this.hasFocus = false
    }
  },
  computed: {
    getExternalClass () {
      return this.domClass
    },
    isFocused () {
      return this.hasFocus ? 'form__input--focus' : ''
    }
  }
}
</script>
